import { WhatsNewModal as WhatsNewModalShell } from '@odo/shared-ui';
import React from 'react';
import { slides } from './WhatsNewContent';
import { useWhatsNew } from './useWhatsNew';

const WhatsNewModal: React.FC = () => {
    const { shouldShow, onDismiss } = useWhatsNew();

    return (
        <WhatsNewModalShell
            open={shouldShow}
            slides={slides}
            onDismiss={onDismiss}
            dismissible={false}
        />
    );
};

export default WhatsNewModal;
